// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3SI51","col":"styles_col__Yk9SV"};